import { UserActivityApi } from "../../../Shared/Constants/api";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";

export const getUserActivityApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${UserActivityApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
